import supabaseClient from '@/api/supabaseClient.ts';
import { useQuery } from '@tanstack/react-query';

export type CarerOnboarding = {
  id: string;
  user_id: string;
  email: string;
  photo_url: string | null;
  bio: string | null;
  care_types: string[];
  skills: string[];
  hourly_rate: number;
  service_area: string;
  availability_dates: any;
  dbs_document_url: string | null;
  insurance_document_url: string | null;
  created_at: string;
  updated_at: string;
};

const useAdminCarerOnboarding = (userId: string | undefined) => {
  const queryFn = async (): Promise<CarerOnboarding | null> => {
    if (!userId) return null;

    console.log('Fetching carer onboarding for user:', userId);

    // First check current user role
    const { data: currentUserData } = await supabaseClient
      .from('users')
      .select('role')
      .eq('id', (await supabaseClient.auth.getUser()).data.user?.id)
      .single();
    
    console.log('Current user role:', currentUserData?.role);

    const { data, error } = await supabaseClient
      .from('business_onboarding')
      .select('*')
      .eq('user_id', userId)
      .maybeSingle();

    if (error) {
      console.error('Error fetching carer onboarding:', error);
      throw new Error(error.message);
    }

    console.log('Carer onboarding data:', data);
    return data;
  };

  return useQuery<CarerOnboarding | null, Error>({
    queryKey: ['admin-carer-onboarding', userId],
    queryFn,
    enabled: !!userId,
  });
};

export default useAdminCarerOnboarding;
